/** Bounds and choices of a thematic meeting, shared by its creation flow and its plan. */

// The bound the user is held to, in plain text: what the message cites and what they can see they
// typed — not the HTML the field actually submits (see `CONTEXT_HTML_MAX_LENGTH` below).
export const CONTEXT_MAX_LENGTH = 2000;

// The bound the writer is held to, in plain text: what the editor's counter shows and what a
// refusal cites -- not the HTML the field submits (see `PREPARATION_NOTES_HTML_MAX_LENGTH` below).
export const PREPARATION_NOTES_MAX_LENGTH = 5000;

// `ContextField`/`PreparationSection` submit `slateToHtml` output, not the plain text the editor
// counts: this is what zod (and the backend, in parallel) actually validates the field against,
// wide enough to fit the markup around `CONTEXT_MAX_LENGTH` worth of text.
export const CONTEXT_HTML_MAX_LENGTH = 4000;

// Same bound as the server's `ThematicMeetingLimits.MaxPreparationNotesLength`, on the stored HTML.
// Heavy formatting reaches it long before the text bound is in sight, so the editor holds the notes
// to both.
export const PREPARATION_NOTES_HTML_MAX_LENGTH = 10000;

// Same bound as the server's validator.
export const MEETING_TITLE_MAX_LENGTH = 150;

export const MEETINGS_PAGE_SIZE = 10;

export const RECENT_ACTIVITY_COUNT = 5;
